module.exports = __webpack_public_path__ + "fork_slight_left.svg?cf02bc0dfe809432f4ba0121f3f99007";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/fork_slight_left.svg
// module id = 167
// module chunks = 0